export function checkAdmin(org: string) {
  return org === 'idealsystemsadmin'
}
